// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardMain {
  background-color: #fff;
}

.card {
  padding: 16px;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  background-color: #fff;
  width: 100%;
  max-width: 100%;
}
@media (max-width: 768px) {
  .card h6 {
    font-size: 20px !important;
  }

  .card p {
    font-size: 14px;
  }
}

.cardMainWrapper {
  display: grid;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.cardMainWrapper > :last-child {
  width: 20%;
}

.cardWrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 80%;
  gap: 14px;
}
.card p {
  font-size: 14px;
  color: rgba(129, 129, 129, 1);
  font-weight: 600;
}

.garbageCard {
  display: flex;
  padding: 12px 10px;
  align-items: center;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  background-color: #fff;
}

.garbageCard p {
  font-size: 14px;
  color: rgba(129, 129, 129, 1);
  font-weight: 600;
  margin-bottom: 12px;
}

.garbageCard h5 {
  margin-bottom: 0px;
}

.doubleBarGraphWrapper {
  padding: 20px;
  border-radius: 12px;
  height: 500px;
  position: relative;
}
.DoughnutChartWrapper {
  padding: 20px;
  border-radius: 12px;
  width: 400px;
}

.chartContainer {
  height: 86%;
  width: 100%;
  overflow-x: auto;
}

.collectionchartContainer {
  height: 92%;
  width: 100%;
  overflow-x: auto;
}

@media (max-width: 1200px) {
  .cardWrapper {
    grid-template-columns: repeat(3, 1fr);
  }

  .cardWrapper {
    width: 75%;
  }

  .cardMainWrapper > :last-child {
    width: 25%;
  }
}

@media (max-width: 900px) {
  .cardWrapper {
    grid-template-columns: repeat(2, 1fr);
    width: 70%;
  }

  .cardMainWrapper > :last-child {
    width: 30%;
  }

  .doubleBarGraphWrapper {
    height: 400px;
  }
}

@media (max-width: 575px) {
  .cardWrapper {
    grid-template-columns: repeat(1, 1fr);
    width: 90%;
    margin: 0 auto;
  }
  .cardMainWrapper{
    flex-direction: column;
  }
  .cardMainWrapper > :last-child {
  width: 90%;
  margin: 0 auto;
}

}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;IACV,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;EACA,UAAU;EACV,cAAc;AAChB;;AAEA","sourcesContent":[".dashboardMain {\n  background-color: #fff;\n}\n\n.card {\n  padding: 16px;\n  border-radius: 12px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;\n  background-color: #fff;\n  width: 100%;\n  max-width: 100%;\n}\n@media (max-width: 768px) {\n  .card h6 {\n    font-size: 20px !important;\n  }\n\n  .card p {\n    font-size: 14px;\n  }\n}\n\n.cardMainWrapper {\n  display: grid;\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.cardMainWrapper > :last-child {\n  width: 20%;\n}\n\n.cardWrapper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  width: 80%;\n  gap: 14px;\n}\n.card p {\n  font-size: 14px;\n  color: rgba(129, 129, 129, 1);\n  font-weight: 600;\n}\n\n.garbageCard {\n  display: flex;\n  padding: 12px 10px;\n  align-items: center;\n  border-radius: 12px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;\n  background-color: #fff;\n}\n\n.garbageCard p {\n  font-size: 14px;\n  color: rgba(129, 129, 129, 1);\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.garbageCard h5 {\n  margin-bottom: 0px;\n}\n\n.doubleBarGraphWrapper {\n  padding: 20px;\n  border-radius: 12px;\n  height: 500px;\n  position: relative;\n}\n.DoughnutChartWrapper {\n  padding: 20px;\n  border-radius: 12px;\n  width: 400px;\n}\n\n.chartContainer {\n  height: 86%;\n  width: 100%;\n  overflow-x: auto;\n}\n\n.collectionchartContainer {\n  height: 92%;\n  width: 100%;\n  overflow-x: auto;\n}\n\n@media (max-width: 1200px) {\n  .cardWrapper {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .cardWrapper {\n    width: 75%;\n  }\n\n  .cardMainWrapper > :last-child {\n    width: 25%;\n  }\n}\n\n@media (max-width: 900px) {\n  .cardWrapper {\n    grid-template-columns: repeat(2, 1fr);\n    width: 70%;\n  }\n\n  .cardMainWrapper > :last-child {\n    width: 30%;\n  }\n\n  .doubleBarGraphWrapper {\n    height: 400px;\n  }\n}\n\n@media (max-width: 575px) {\n  .cardWrapper {\n    grid-template-columns: repeat(1, 1fr);\n    width: 90%;\n    margin: 0 auto;\n  }\n  .cardMainWrapper{\n    flex-direction: column;\n  }\n  .cardMainWrapper > :last-child {\n  width: 90%;\n  margin: 0 auto;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
